import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const currentLayout = window.$environment.CURRENT_LAYOUT;
const baseUrl = currentLayout === 'SpireonNew' ? '/spireon' : '';

const leftMenu = [
  {
    icon: mediaUrls.logs,
    label: 'leftMenu.logs',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER'],
    path: baseUrl + '/logs',
  },
  {
    icon: mediaUrls.user,
    label: 'Drivers Status',
    roles: ['FLMANAGER', 'ADMIN'],
    path: baseUrl + '/driverStatus/more',
  },

  {
    icon: mediaUrls.inspections,
    label: 'leftMenu.inspections',
    roles: ['FLMANAGER', 'ADMIN'],
    path: baseUrl + '/inspections',
  },
  {
    icon: mediaUrls.reports,
    label: 'leftMenu.reports',
    roles: ['FLMANAGER', 'ADMIN'],
    path: baseUrl + '/report',
  },
  {
    icon: mediaUrls.policy,
    label: 'leftMenu.policiesProcedures',
    roles: ['FLMANAGER', 'ADMIN'],
    path: baseUrl + '/policy/edit',
  },
];
export default leftMenu;
